import types from 'constants/UserConstants';
import Cookies from 'js-cookie';
import axios from 'axios';
import qs from 'qs';
import {
  fetchSessionSetting,
  prepareRefreshSessionSetting
} from './SessionActions';
import {getURL} from '../routes';

export function fetchUserListAPI() {
  return axios.get(getURL("/api/user"))
}

export function fetchUserDataAPI(uid) {
  return axios.get(getURL("/api/user/") + uid)
}

export function uploadFileAPI(file) {
  let data = new FormData();
  data.append('file', file);

  return axios.post(getURL('/api/upload'), data)
}

export function fetchPositionListAPI() {
  return axios.get(getURL('/api/position'))
}

export function addPositionAPI(name) {
  return axios.post(getURL('/api/position'),
                qs.stringify({'name': name}))
}

export function updatePositionNameAPI(id, name) {
  return axios.put(getURL('/api/position/') + id,
                qs.stringify({'name': name}))
}

export function deletePositionAPI(id) {
  return axios.delete(getURL('/api/position/') + id)
}

export function updatePositionTypeAPI(id, type) {
  return axios.put(getURL('/api/position/') + id,
                qs.stringify({'action': type == 0 ? 'as_position' : 'as_category'}))
}

export function updateUserDataAPI(userInfo) {
  return axios.put(getURL("/api/user/") + userInfo.uid,
            qs.stringify(userInfo))
}

export function addUserAPI(userInfo) {
  return axios.post(getURL("/api/user"),
            qs.stringify(userInfo))
}

export function fetchPositionList() {
  return dispatch => {
    fetchPositionListAPI()
      .then((response) => {
        let {position} = response.data;
        dispatch(refreshPositionList(position));
      })
      .catch((error) => {

      })
  }
}

export function tryUpdatePositionName(id, name) {
  return dispatch => {
    updatePositionNameAPI(id, name)
      .then((response) => {
        dispatch(updatePositionName(id, name))
      })
      .catch((error) => {

      })
  }
}

export function tryAddPosition(name) {
  return dispatch => {
    addPositionAPI(name)
      .then((response) => {
        let {id} = response.data;
        dispatch(addPosition(id, name))
      })
      .catch(() => {
        alert("新增公司失敗")
      })
  }
}

export function tryDeletePosition(id) {
  return dispatch => {
    deletePositionAPI(id)
      .then((response) => {
        dispatch(deletePosition(id))
      })
      .catch((error) => {
        alert("删除失敗!")
      })
  }
}

export function tryUpdatePositionType(id, type) {
  return dispatch => updatePositionTypeAPI(id, type)
    .then(response => {
      dispatch(updatePositionType(id, type))
    })
    .catch((error) => {
      alert("更改失敗")
    })
}

export function tryUploadFile(file) {
  uploadFileAPI(file)
    .then((response) => {
      let {fname} = response.data;
      return fname
    })
    .catch((e) => {
      console.error(e);
    })
}

export function tryUploadFileForUserInfo(file, setFname, finish) {
  uploadFileAPI(file)
    .then((response) => {
      let {fname} = response.data;
      setFname(fname);
      finish();
    })
    .catch((e) => {
      console.error(e);
      finish();
    })
}

export function fetchUserList() {
  return dispatch => {
  fetchUserListAPI()
      .then(function(response) {
        let {userList} = response.data;
        dispatch(resetUserList(userList));
      })
      .catch(function(error) {

      });
  }
}

export function resetUserList(userList) {
	return {
		type: types.RESET_USER_LIST,
		userList,
	}
}

export function resetUserData(userData) {
  return {
    type: types.RESET_USER_DATA,
    userData,
  }
}

export function appendUserList(uid, name, role, status) {
  return {
    type: types.APPEND_USER_LIST,
    uid, name, role, status
  }
}

export function updateUserList(uid, name, role, status) {
  return {
    type: types.UPDATE_USER_LIST,
    uid, name, role, status
  }
}

export function refreshPositionList(positions) {
  return {
    type: types.REFRESH_POSITION_LIST,
    positions
  }
}

export function updatePositionName(id, name) {
  return {
    type: types.UPDATE_POSITION_NAME,
    id, name
  }
}

export function updatePositionType(id, type) {
  return {
    type: types.UPDATE_POSITION_TYPE,
    id, toType:type
  }
}


export function deletePosition(id) {
  return {
    type: types.DELETE_POSITION,
    id
  }
}

export function addPosition(id, name) {
  return {
    type: types.ADD_POSITION,
    id, name
  }
}

//--------------------------WELL DONE-----------------------//

//fetchUserData, addUser, updateUser


export function fetchDailySalary(uid, year, month) {
  let token = Cookies.get('sx');

  return axios.get(getURL("/api/salary/") + uid + "?" +
                    qs.stringify({
                      'sx': token,
                      'year': year,
                      'month': month
                    }))
}

export function fetchSalaryAdjust(uid, year, month) {
  return axios.get(getURL("/api/salary/") + uid + "?" +
                    qs.stringify({
                      'year': year,
                      'month': month,
                      'type': 'adjust'
                    }))
}

export function fetchUserShiftRecord(uid, year, month) {
  return axios.get(getURL("/api/record?") +
                    qs.stringify({
                      'uid': uid,
                      'year': year,
                      'month': month
                    }))
}

export function fetchShiftRecordDetail(uid, date, sid) {
  return axios.get(getURL("/api/record/") + uid + "?" +
                    qs.stringify({
                      'date': date,
                      'sid': sid
                    }))
}

export function editSalaryAdjust({uid, id, amount, typeID, note}) {
  let token = Cookies.get('sx');
  return axios.put(getURL("/api/salary/") + uid,
            qs.stringify({
              'sx': token,
              'adjustID': id,
              'amount': amount,
              'note': note,
              'typeID': typeID,
              'action': "adjust"
            }))
}

export function attempEditSalaryAdjust(oldVal, newVal) {
  return (dispatch, getState) => {
    let uid = getState().user.get('selected');
    dispatch(updateSalaryAdjustDetail({...newVal}))
    editSalaryAdjust({uid, ...newVal})
      .then((response) => {
      })
      .catch((error) => {
        dispatch(updateSalaryAdjustDetail({...oldVal}))
      })
  }
}

export function createSalaryAdjust(uid, amount, typeID, note, year, month) {
  let token = Cookies.get('sx');

  return axios.post(getURL("/api/salary/") + uid,
            qs.stringify({
              'sx': token,
              'amount': amount,
              'typeID': typeID,
              'note': note,
              'year': year,
              'month': month
            }))
}

export function attempCreateSalaryAdjust(amount, typeID, note, finishCreate) {
  return (dispatch, getState) => {
    let uid = getState().user.get('selected');
    let year = getState().user.get('year');
    let month = getState().user.get('month');

    createSalaryAdjust(uid, amount, typeID, note, year, month)
      .then((response) => {
        dispatch(updateSalaryAdjustDetail({id: response.data.adjustID, amount: amount, typeID: typeID, note: note}))
        finishCreate()
      })
      .catch((error) => {
        finishCreate()
      })
  }
}

export function delSalaryAdjust(id) {
  return axios.delete(getURL("/api/salary/") + id)
}

export function attempDelSalaryAdjust(id) {
  return (dispatch, getState) => {
    delSalaryAdjust( id)
      .then((response) => {
        dispatch(delSalaryAdjustDetail(id));
      })
      .catch((error) => {

      })
  }
}

export function fetchSessionConfig() {
  return (dispatch) => {
    fetchSessionSetting()
      .then((response) => {
        dispatch(prepareRefreshSessionSetting(response.data));
      })
      .catch((error) => {

      })
  }
}

export function fetchSelectedUserInfo() {
  return (dispatch, getState) => {
    let uid = getState().user.get('selected');
    let year = getState().user.get('year');
    let month = getState().user.get('month');

    dispatch(startLoadingUserData());
    Promise.all([
      fetchDailySalary(uid, year, month),
      fetchSalaryAdjust(uid, year, month),
      fetchUserShiftRecord(uid, year, month),
    ])
      .then((responses) => {
        let [
          dailySalary,
          salaryAdjust,
          shiftRecord
        ] = responses;

        dispatch(updateDailySalary(dailySalary.data.dailySalary));
        dispatch(updateSalaryAdjust(salaryAdjust.data.salaryAdjust));
        dispatch(updateUserShiftRecord(shiftRecord.data.shiftRecord));
      })
      .catch((error) => {
      })
      .then( () => {
        dispatch(finishLoadingUserData());
      })

  }
}

export function tryUpdateDailySalary(origin, dailySalary) {
  return (dispatch, getState) => {
    let uid = getState().user.get('selected');
    let year = getState().user.get('year');
    let month = getState().user.get('month');

    dispatch(updateDailySalary(dailySalary));
    updateDailySalaryToServer(uid, dailySalary, year, month)
      .then((response) => {

      })
      .catch((error) => {
        dispatch(updateDailySalary(origin));
      })
  }
}

export function updateDailySalaryToServer(uid, dailySalary, year, month) {
  let token = Cookies.get('sx');
  return axios.put(getURL("/api/salary/") + uid,
            qs.stringify({
              'sx': token,
              'year': year,
              'month': month,
              'amount': dailySalary
            }))
}

export function createShiftRecord(data) {
  return axios.post(getURL("/api/record"), data)
}

export function createHolidayRecordAPI(data) {
  return axios.post(getURL("/api/record"),  qs.stringify(data))
}

export function prepareCreateShiftRecord({mornShift, aftnShift, otShift, selectedCid, selectedPid, date, dayLast}) {
  return (dispatch, getState) => {
    let uid = getState().user.get('selected');
    let year = getState().user.get('year');
    let month = getState().user.get('month');
    let shiftList = [];
    mornShift && shiftList.push(0);
    aftnShift && shiftList.push(1);
    otShift && shiftList.push(2);
    let reqData = {
      cid: selectedCid,
      uid: uid,
      pid: selectedPid,
      startAt: date.format("YYYY-MM-DD"),
      lastFor: parseInt(dayLast, 10) || 1,
      shiftList: shiftList
    }

    createShiftRecord(reqData)
      .then((response) => {
        fetchUserShiftRecord(uid, year, month)
          .then((response) => {
            dispatch(updateUserShiftRecord(response.data.shiftRecord))
          })
      })
      .catch((error) => {

      })
  }
}

export function createHolidayRecord(weekday) {
  return (dispatch, getState) => {
    let uid = getState().user.get('selected');
    let year = getState().user.get('year');
    let month = getState().user.get('month');

    let reqData = {
      action: 'create_dutyof_record',
      uid,
      date: `${year}-${month}-01`,
      weekday
    }
    return createHolidayRecordAPI(reqData)
      .then((response) => {
        if (!response.data.success) {
          throw new Error();
        }
        fetchUserShiftRecord(uid, year, month)
          .then((response) => {
            dispatch(updateUserShiftRecord(response.data.shiftRecord))
          })
      })
  }
}

export function CreateShiftRecordInPast(data){
  return (dispatch, getState) => {
    let uid = getState().user.get('selected');
    let year = getState().user.get('year');
    let month = getState().user.get('month');

    data.uid = uid
    createShiftRecord(data)
      .then((response) => {
        fetchUserShiftRecord(uid, year, month)
          .then((response) => {
            dispatch(updateUserShiftRecord(response.data.shiftRecord))
          })
      })
      .catch((error) => {

      })
  }
}

export function updateRecordSite(uid, date, sid, cid, pid) {
  return axios.put(getURL("/api/record/") + uid,
              qs.stringify({
                'action': 'update_site',
                'date': date,
                'sid': sid,
                'cid': cid,
                'pid': pid
              }))
}

export function updateCheckinState(id, status) {
  return axios.put(getURL("/api/record/") + id,
              qs.stringify({
                'action': (status === 0? "inactive" :"active")
              }))
}

export function attempUpdateCheckinState(id, status, fn) {
  return (dispatch, getState) => {
    let uid = getState().user.get('selected');
    let year = getState().user.get('year');
    let month = getState().user.get('month');

    updateCheckinState(id, status)
      .then((response) => {
        fn();
        fetchUserShiftRecord(uid, year, month)
          .then((response) => {
            dispatch(updateUserShiftRecord(response.data.shiftRecord))
          })
      })
      .catch((error) => {

      })
  }
}

export function updateRecordOTOffset(uid, date, sid, offset) {
  return axios.put(getURL("/api/record/") + uid,
              qs.stringify({
                'action': "offset",
                'date': date,
                'sid': sid,
                'offset': offset
              }))
}

export function attempUpdateRecordOTOffset(uid, date, sid, offset, fn) {
  return (dispatch, getState) => {
    let uid = getState().user.get('selected');
    let year = getState().user.get('year');
    let month = getState().user.get('month');

    updateRecordOTOffset(uid, date, sid, offset)
      .then((response) => {
        fn();
        fetchUserShiftRecord(uid, year, month)
          .then((response) => {
            dispatch(updateUserShiftRecord(response.data.shiftRecord))
          })
      })
      .catch((error) => {

      })
  }
}

export function attempUpdateRecordSite(uid, date, sid, cid, pid=0) {
  return (dispatch, getState) => {
    let uid = getState().user.get('selected');
    let year = getState().user.get('year');
    let month = getState().user.get('month');

    updateRecordSite(uid, date, sid, cid, pid)
      .then((response) => {
        fetchUserShiftRecord(uid, year, month)
          .then((response) => {
            dispatch(updateUserShiftRecord(response.data.shiftRecord))
          })
      })
      .catch((error) => {

      })
  }
}

export function attempConfirmRecord(uid, date, sid, confirm=true) {
  return (dispatch) => {
    axios.put(getURL("/api/record/") + uid,
                qs.stringify({
                  'date': date,
                  'sid': sid,
                  'action': (confirm? "confirm" : "unconfirm")
                }))
    .then((response) => {
      dispatch(confirmRecord(date.slice(-2) + '-' + sid, confirm));
    })
    .catch((error) => {

    })
  }
}


export function delSalaryAdjustDetail(id) {
  return {
    type: types.REMOVE_SALARY_ADJUST,
    id
  }
}

export function updateSalaryAdjustDetail({id, amount, typeID, note}) {
  return {
    type: types.UPDATE_SALARY_ADJUST_DETAIL,
    id, amount, typeID, note
  }
}

export function updateDailySalary(dailySalary) {
  return {
    type: types.UPDATE_DAILY_SALARY,
    dailySalary,
  }
}

export function updateSalaryAdjust(salaryAdjust) {
  return {
    type: types.UPDATE_SALARY_ADJUST,
    salaryAdjust,
  }
}

export function updateUserShiftRecord(shiftRecord) {
  return {
    type: types.UPDATE_SHIFT_RECORD,
    shiftRecord
  }
}

export function switchSelectedUser(uid) {
  return {
    type: types.SWITCH_SELECTED_USER,
    uid,
  }
}

export function switchYear(year) {
  return {
    type: types.SWITCH_YEAR,
    year,
  }
}

export function switchMonth(month) {
  return {
    type: types.SWITCH_MONTH,
    month,
  }
}

export function confirmRecord(id, confirm) {
  return {
    type: types.CONFIRM_RECORD,
    id, confirm
  }
}

export function startLoadingUserData() {
  return {
    type: types.START_LOADING_USER_DATA,
  }
}

export function finishLoadingUserData() {
  return {
    type: types.FINISH_LOADING_USER_DATA,
  }
}



// WEBPACK FOOTER //
// ./src/actions/UserActions.js